import {Box, Colors, Text} from "@bounce/shared/ui";
import HtmlFrame from "./HtmlFrame";

type LandingPageViewProps = {
  html: string;
};

const LandingPageView = ({html}: LandingPageViewProps) => {
  if (!html.trim()) {
    return (
      <Box sx={{height: "100%", display: "flex", alignItems: "center", justifyContent: "center", px: 3}}>
        <Text size={13} sx={{color: Colors.grey._500, textAlign: "center"}}>
          Landing page body is empty.
        </Text>
      </Box>
    );
  }
  return <HtmlFrame html={html} title="Landing page preview" sx={{height: "100%"}} />;
};

export default LandingPageView;
